import { CaretLeft } from "@phosphor-icons/react";
import { useEDCFlow } from "@smvtech/x-flux";
import { Flag } from "x-wings";
import { Flags } from "x-wings/Components/Flag/types";

type Props = {
	onPrev: () => void;
	onSelectDocuments: () => void;
	onSelectForm: () => void;
};

const VisaRequirementsScreen = ({ onPrev, onSelectDocuments, onSelectForm }: Props) => {
	const { order } = useEDCFlow();

	return (
		<div className="h-dvh w-full overflow-hidden bg-white flex flex-col">
			<div className="flex items-center justify-between py-[13px] px-4 bg-white border-b border-gray-100 shrink-0">
				<button onClick={onPrev} className="p-1 -ml-1">
					<CaretLeft size={20} />
				</button>
				<span className="text-sm font-medium text-gray-900">Visa Requirements</span>
				<div className="w-5" />
			</div>

			<div className="mt-[19px] flex justify-center shrink-0">
				<div className="flex items-center gap-2">
					<Flag code={order?.country?.symbol as Flags} size="m" hasBorder hasBorderRadius hasDropShadow />
					<span className="font-medium text-sm uppercase">{order?.country?.name}</span>
				</div>
			</div>

			<div className="flex-1 flex flex-col items-center justify-center px-6 min-h-0">
				<div className="w-full max-w-sm flex flex-col items-center">
					<h1 className="text-lg font-semibold text-black mb-6">Let’s begin</h1>

					<div className="w-full flex gap-3">
						<button onClick={onSelectDocuments} className="flex-1 flex flex-col items-center">
							<div className="relative w-full aspect-[4/5] max-h-[185px] rounded-2xl border-2 border-[#4E45C4] bg-white flex items-center justify-center shadow-sm">
								<span className="absolute top-3 left-3 text-[10px] bg-[#4E45C4] text-white px-2 py-0.5 rounded-full font-bold">
									Preferred
								</span>
								<img
									src="https://stampmyvisa-public.s3.ap-south-1.amazonaws.com/biz-share-questionnaire/documents.png"
									alt="documents"
									className="w-[70%] h-auto object-contain"
								/>
							</div>
							<div className="mt-3 text-sm font-bold text-black leading-tight">Documents</div>
							<div className="text-[10px] font-medium text-gray-500">Takes 2–3 minutes</div>
						</button>
						<button onClick={onSelectForm} className="flex-1 flex flex-col items-center">
							<div className="w-full aspect-[4/5] max-h-[185px] rounded-2xl border border-gray-200 bg-white flex items-center justify-center">
								<img
									src="https://stampmyvisa-public.s3.ap-south-1.amazonaws.com/biz-share-questionnaire/form.png"
									alt="form"
									className="w-[65%] h-auto object-contain"
								/>
							</div>
							<div className="mt-3 text-sm font-bold text-black leading-tight">Form</div>
							<div className="text-[10px]">&nbsp;</div>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default VisaRequirementsScreen;

